import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {User} from "../../../model/user";
import {UserServiceService} from "../../../service/user-service.service";
import {PlatformService} from "../../../service/platform.service";
import { LoginIdService } from "../../../service/login-id.service";
import * as Sentry from "@sentry/angular";

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.css']
})
export class LoginFormComponent {
  credentials = {username: '', password: ''};
  returnUrl: string
  loginError: boolean = false;
  user: User;
  businessAccount: boolean = false;
  showContactSupportModal: boolean = false;
  logins: login[] = [];

  constructor(private loginIdService: LoginIdService, private router: Router,
              private route: ActivatedRoute, private userService: UserServiceService,
              private platformService: PlatformService) { }

  ngOnInit() {
    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    const subDomain = this.findSubDomain();

    if(subDomain !== "connect" && subDomain !== "docestate"){
        // if subdomain is for example beos fetch their profile logins and assign them to the login array
        this.platformService.getLogins(subDomain).subscribe(
                data => this.logins = Object.entries(data).map(([standort, mail]) => ({ standort, mail }))
                , error => console.log(error)
        );
    }
    this.credentials.username = "";
  }

  async login() {
    try {
      if(this.returnUrl !== '/cart'){
        this.loginIdService.clearSessionStorageBeforeLogin();
      }
      this.trimCredentials();
      await this.loginIdService.authenticate(this.credentials);
      this.loginError = false;
      await this.loginIdService.authenticated();
      await this.loginIdService.loginServiceInitialized$.toPromise();
      await this.router.navigateByUrl(this.returnUrl);
    } catch (error) {
      this.loginError = true;
      await this.loginIdService.loggedOut(true);
      Sentry.captureException(error);
      console.log(error);
    }
  }

  hasLogins(): boolean {
    return this.logins ? this.logins.length > 0 : false;
  }

  findSubDomain() {
    let url: string = document.URL;
    let queryParamIndex = url.indexOf("?")
    if (queryParamIndex !== -1) {
      url = document.URL.substring(0, queryParamIndex)
    }
    url = url.replace("www.", "");
    let index = url.indexOf(".");
    return index > 0 ? url.substring(0, index)
      .replace("http://", "")
      .replace("https://", "")
      .replace(".", "") : "docestate";
  }

  /**
   * Trims the leading and trailing white spaces from the username and password
   */
  private trimCredentials(): void{
    this.credentials.username = this.credentials.username.trim();
    this.credentials.password = this.credentials.password.trim();
  }
}

interface login {
  standort: string,
  mail: string
}
